import React from "react";
import { profileMenuItems } from "./ProfileMenuItems";
import ProfileMenu from "./ProfileMenu";

const UserProfileMenu = () => {
  const menuItems = profileMenuItems.map((item, index) => {
    return <ProfileMenu title={item.title} items={item.items} key={index} />;
  });
  return <div className="w-100">{menuItems}</div>;
};

export default UserProfileMenu;
